var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83888 4.3837V17.1591C7.09549 16.4959 6.1159 16.0922 5.04363 16.0922C2.72567 16.0922 0.839844 17.978 0.839844 20.296C0.839844 22.6141 2.72567 24.4999 5.04363 24.4999C7.35874 24.4999 9.24259 22.6188 9.24737 20.3048H9.24747V10.0378L21.7517 6.86802V13.7678C21.0083 13.1046 20.0287 12.7009 18.9565 12.7009C16.6385 12.7009 14.7526 14.5867 14.7526 16.9047C14.7526 19.2227 16.6385 21.1085 18.9565 21.1085C21.2744 21.1085 23.1603 19.2227 23.1603 16.9047V0.499878L7.83888 4.3837Z",
    fill: "#F2EADF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.24470fcbcc1a636048c5312927fb386c.svg";
export { ForwardRef as ReactComponent };